import { useEffect } from "react";
import { Phone, Mail, MapPin, MessageCircle, Clock, Navigation, Instagram, Facebook, Music2 } from "lucide-react";
import { useLang } from "@/i18n";
import { GARAGE, waLink } from "@/config";

export default function Contact() {
  const { t } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(GARAGE.mapsQuery)}`;

  return (
    <div className="container-x py-14" data-testid="contact-page">
      <p className="overline-red">Milano Worx</p>
      <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white">{t("contact.title")}</h1>
      <p className="mt-3 text-zinc-400">{t("contact.sub")}</p>

      <div className="mt-10 grid lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          <div className="card-dark p-5" data-testid="contact-info-card">
            <h3 className="font-heading font-bold text-white text-lg">{GARAGE.name}</h3>
            <div className="mt-4 space-y-3 text-sm">
              <p className="flex items-center gap-3 text-zinc-300"><MapPin size={16} className="text-[#E11D48] shrink-0" />{GARAGE.address}</p>
              <a href={GARAGE.phoneHref} data-testid="contact-phone" className="flex items-center gap-3 text-zinc-300 hover:text-white transition-colors">
                <Phone size={16} className="text-[#E11D48] shrink-0" />{GARAGE.phoneDisplay}
              </a>
              <a href={waLink(t("wa.general"))} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-3 text-zinc-300 hover:text-white transition-colors">
                <MessageCircle size={16} className="text-[#22C55E] shrink-0" />WhatsApp
              </a>
              <a href={`mailto:${GARAGE.email}`} data-testid="contact-email" className="flex items-center gap-3 text-zinc-300 hover:text-white transition-colors">
                <Mail size={16} className="text-[#E11D48] shrink-0" />{GARAGE.email}
              </a>
            </div>
            <a href={mapsUrl} target="_blank" rel="noreferrer" data-testid="contact-route-btn" className="btn-red mt-5 w-full !py-2.5 text-sm">
              <Navigation size={15} />{t("contact.route")}
            </a>
            <div className="flex gap-3 mt-4">
              <a href={GARAGE.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="p-2.5 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Instagram size={18} /></a>
              <a href={GARAGE.tiktok} target="_blank" rel="noreferrer" data-testid="contact-tiktok" className="p-2.5 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Music2 size={18} /></a>
              <a href={GARAGE.facebook} target="_blank" rel="noreferrer" data-testid="contact-facebook" className="p-2.5 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Facebook size={18} /></a>
            </div>
          </div>

          <div className="card-dark p-5" data-testid="contact-hours-card">
            <h3 className="flex items-center gap-2 font-heading font-bold text-white"><Clock size={16} className="text-[#E11D48]" />{t("contact.hours")}</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {GARAGE.hours.map(([day, time]) => (
                <li key={day} className="flex justify-between text-zinc-400 border-b border-zinc-800/60 pb-2 last:border-0">
                  <span>{day}</span><span className="font-mono2 text-zinc-300">{time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="card-dark overflow-hidden min-h-[380px]" data-testid="contact-map">
          <iframe
            title="Google Maps"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(GARAGE.mapsQuery)}&output=embed`}
            className="w-full h-full min-h-[380px] border-0"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
